import React from 'react';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { LoadingShimmer } from '~/eds/src/components/LoadingShimmer/LoadingShimmer';
import { useIntl } from 'react-intl';
import Link from '~/ui/components/Link/Link';

export const SeeMoreFiles = ({ indent, isLoading, onClick }) => {
  const intl = useIntl();
  return (
    <>
      {isLoading ? (
        <LoadingShimmer />
      ) : (
        <Layout ml={indent * 40} align="center" spacing={1}>
          <Icon icon="more" />
          <Link
            shouldTruncate={true}
            shouldWrap={false}
            onClick={onClick}
            variant="m-spaced"
          >
            {intl.formatMessage({
              id: 'SeeMoreFiles.seeMoreFilesLink',
              defaultMessage: 'See more files',
              description:
                'Link to load more files in the group documents table',
            })}
          </Link>
        </Layout>
      )}
    </>
  );
};
